<template>
    <div>
        <PatientInformation :branch-id="branchId" :is-editing="!isEditing" />
        <RaceEthnicity class="mt-2" />
        <PatientLanguage class="mt-2" />
        <PaymentSource class="mt-2" />
        <AdmissionSource class="mt-2" />
        <EpisodeManagement class="mt-2" />
        <DemographicsTags class="mt-2" />
    </div>
</template>

<style lang="scss">
.no-border-radius {
    border-radius: 0 !important;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";

import PatientInformation from "./PatientInformation/PatientInformation.vue";
import RaceEthnicity from "./RaceEthnicity/RaceEthnicity.vue";
import PatientLanguage from "./PatientLanguage/PatientLanguage.vue";
import PaymentSource from "./PaymentSource/PaymentSource.vue";
import AdmissionSource from "./AdmissionSource/AdmissionSource.vue";
import EpisodeManagement from "./EpisodeManagement/EpisodeManagement.vue";
import DemographicsTags from "./Tags/DemographicsTags.vue";

export default defineComponent({
    props: {
        branchId: {
            type: String
        },
        isEditing: {
            type: Boolean
        }
    },
    components: {
        PatientInformation,
        RaceEthnicity,
        PatientLanguage,
        PaymentSource,
        AdmissionSource,
        EpisodeManagement,
        DemographicsTags
    }
});
</script>
